<section
  class="p-4 flex-table-page routed-flex-table-page bg-white flex flex-col gap-4 font-['Poppins',sans-serif]"
  data-testid="quota-policy-page"
>
  <p-toast />
  <header class="flex flex-wrap items-center justify-between gap-3">
    <div class="flex flex-col gap-0.5">
      <h2 class="text-2xl font-semibold text-gray-800">
        {{ 'flash_sale_quota.title' | translate }}
      </h2>
      <p class="text-xs font-medium text-gray-500">
        {{ 'flash_sale_quota.subtitle' | translate }}
      </p>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      @if (canCreate()) {
        <button
          type="button"
          class="cursor-pointer rounded-md bg-blue-600 hover:bg-blue-700 px-3.5 py-2 text-xs font-medium text-white transition-colors"
          data-testid="quota-policy-create-btn"
          (click)="openCreate()"
        >
          {{ 'flash_sale_quota.actions.create' | translate }}
        </button>
      }
    </div>
  </header>

  <div class="table-wrapper overflow-x-auto rounded-lg border border-gray-200 bg-white">
    @if (loading()) {
      <p class="px-4 py-8 text-center text-sm text-gray-500">
        {{ 'flash_sale.messages.loading' | translate }}
      </p>
    } @else {
      <table class="p-datatable-table w-full text-left text-sm" data-testid="quota-policy-table">
        <thead class="p-datatable-thead bg-[#fafafa] border-b border-gray-200">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-700">
              {{ 'flash_sale_quota.columns.name' | translate }}
            </th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-700">
              {{ 'flash_sale_quota.columns.percent' | translate }}
            </th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-700">
              {{ 'flash_sale_quota.columns.active' | translate }}
            </th>
            <th class="px-4 py-3 text-center text-xs font-semibold text-gray-700 w-[1%] whitespace-nowrap">
              {{ 'flash_sale.columns.actions' | translate }}
            </th>
          </tr>
        </thead>
        <tbody class="p-datatable-tbody divide-y divide-gray-200">
          @for (item of items(); track item.id) {
            <tr class="hover:bg-gray-50 transition-colors">
              <td class="px-4 py-3 text-xs font-medium text-gray-800">{{ item.name }}</td>
              <td class="px-4 py-3 text-xs text-gray-700 tabular-nums">{{ item.maxStockPercent }}%</td>
              <td class="px-4 py-3 text-xs text-gray-700">
                <p-tag
                  styleClass="status-tag"
                  [severity]="item.active ? 'success' : 'secondary'"
                  [value]="
                    (item.active ? 'flash_sale_quota.active_yes' : 'flash_sale_quota.active_no')
                      | translate
                  "
                />
              </td>
              <td class="px-4 py-2 text-center whitespace-nowrap">
                <div class="flex items-center justify-center gap-2">
                  @if (canEdit()) {
                    <button
                      type="button"
                      class="cursor-pointer rounded px-2 py-1 text-xs font-medium text-blue-600 hover:bg-gray-100"
                      (click)="openEdit(item)"
                    >
                      {{ 'common.actions.edit' | translate }}
                    </button>
                  }
                  @if (canDelete()) {
                    <button
                      type="button"
                      class="cursor-pointer rounded px-2 py-1 text-xs font-medium text-red-600 hover:bg-gray-100"
                      (click)="remove(item)"
                    >
                      {{ 'common.actions.delete' | translate }}
                    </button>
                  }
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="4" class="px-4 py-10 text-center text-sm text-gray-500">
                {{ 'common.noData' | translate }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  <p-dialog
    [header]="
      (editingId() == null
        ? 'flash_sale_quota.dialog.create'
        : 'flash_sale_quota.dialog.edit'
      ) | translate
    "
    [visible]="dialogOpen()"
    (visibleChange)="dialogOpen.set($event)"
    [modal]="true"
    [style]="{ width: 'min(28rem, 94vw)' }"
  >
    <form class="flex flex-col gap-3 font-['Poppins',sans-serif]" (ngSubmit)="$event.preventDefault(); save()">
      <label class="flex flex-col gap-1 text-xs font-medium text-gray-700">
        <span>{{ 'flash_sale_quota.fields.name' | translate }}</span>
        <input pInputText class="w-full text-xs" [(ngModel)]="name" name="name" />
      </label>
      <label class="flex flex-col gap-1 text-xs font-medium text-gray-700">
        <span>{{ 'flash_sale_quota.fields.percent' | translate }}</span>
        <p-inputNumber
          [(ngModel)]="maxStockPercent"
          name="percent"
          [min]="1"
          [max]="100"
          suffix="%"
          styleClass="w-full"
        />
      </label>
      <label class="flex items-center gap-2 text-xs font-medium text-gray-700 pt-1">
        <p-checkbox [(ngModel)]="activeFlag" [binary]="true" name="active" />
        <span>{{ 'flash_sale_quota.fields.active' | translate }}</span>
      </label>
      <div class="flex justify-end gap-2 pt-3 border-t border-gray-100">
        <button
          type="button"
          class="cursor-pointer rounded-md border border-gray-300 bg-white hover:bg-gray-50 px-3 py-1.5 text-xs font-medium text-gray-700"
          (click)="dialogOpen.set(false)"
        >
          {{ 'common.actions.cancel' | translate }}
        </button>
        <button
          type="submit"
          class="cursor-pointer rounded-md bg-blue-600 hover:bg-blue-700 px-3.5 py-1.5 text-xs font-medium text-white"
          [disabled]="saving()"
        >
          {{ 'common.actions.save' | translate }}
        </button>
      </div>
    </form>
  </p-dialog>
</section>
